module.exports = __webpack_public_path__ + "static/media/alternatives-annotated.55d22fe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/alternatives-annotated.jpg
// module id = 661
// module chunks = 0